import ContenedorSolicitudTurno from '../modules/generarTurno/components/ContenedorSolicitudTurno';
import ContenedorMisTurnos from '../modules/listaTurnos/components/ContenedorMisTurno';
import ContenedorInfoImportante from '../modules/generarTurno/components/ContenedorInfoImportante';
//import ContenedorMiPerfil from 'modules/perfil/components/ContenedorMiPerfil';
import { useAuthContext } from "../context/auth";
//import { useEffect } from 'react';

const Home = () => {

    const { afiliado } = useAuthContext();

    // useEffect(() => {
    //     console.log("useEffect restore prueba ");

    //     console.log("window.location.hash", window.location.hash);
    //     console.log("window.location.search", window.location.search);
    //     if (typeof window !== "undefined") {
  
    //       if (window.location.hash.startsWith("#restore")) {
  
    //         const route = window.location.hash.replace("#restore", "");
  
    //         window.location.hash = "";
  
    //         router.push(route || "/");
  
    //       }
  
    //     }
  
    //   }, []);

    return (
    //         (!afiliado.mail || !afiliado.telefono)
    //     ?
    //         <ContenedorMiPerfil estadoEdicionInicial={true} />
    //     :
    
            <>
                <ContenedorInfoImportante />
                 <ContenedorSolicitudTurno />
                 <ContenedorMisTurnos />
            </>
    )
}

export default Home
